import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
  withCredentials: true  // Send cookies with every request
});

// No need for token interceptor - cookies are sent automatically

export default apiClient;